module.exports = __webpack_public_path__ + "media/images/it/icons/profile-c3ab0f5ba17665627019eff169d4c846.svg";